import { render, staticRenderFns } from "./deleteFile.vue?vue&type=template&id=dc455926&scoped=true&"
import script from "./deleteFile.vue?vue&type=script&lang=js&"
export * from "./deleteFile.vue?vue&type=script&lang=js&"
import style0 from "./deleteFile.vue?vue&type=style&index=0&id=dc455926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc455926",
  null
  
)

export default component.exports